export interface Review {
  id: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  likes: number;
}

export const reviews: Review[] = [
  {
    id: 'rv-1',
    userName: '书虫老张',
    avatar: '',
    rating: 5,
    content: '追了三年了，竹巷老师的文笔真的越来越好。《公厕》这本书从一开始就抓住了我的心，林远这个角色的成长轨迹写得特别真实，那种在城市底层挣扎的感觉，那种不甘平庸却无处可逃的无奈，让我这个北漂看了特别有共鸣。每章结尾都留悬念，根本停不下来！',
    date: '2026-08-06',
    likes: 2356,
  },
  {
    id: 'rv-2',
    userName: '夜雨声烦',
    avatar: '',
    rating: 5,
    content: '终于在笔趣阁找到无删减版了！之前在其他平台看的都是删减版，很多关键情节都被砍掉了，看得莫名其妙。笔趣阁的版本完整无缺，而且更新速度超级快，基本上竹巷老师刚更新几分钟这边就同步了。强烈推荐给所有喜欢现实主义文学的朋友！',
    date: '2026-08-05',
    likes: 1892,
  },
  {
    id: 'rv-3',
    userName: '浮生若梦',
    avatar: '',
    rating: 5,
    content: '这本书最厉害的地方在于，它用一个极其狭窄的物理空间——一间公厕，折射出了整个社会的横截面。各色人等在这里来来往往，每个人都有自己的故事。竹巷对人性的洞察太深刻了，每读一章都有新的感悟。八百万字追下来，值了！',
    date: '2026-08-04',
    likes: 1520,
  },
  {
    id: 'rv-4',
    userName: '江南烟雨',
    avatar: '',
    rating: 4,
    content: '从第一本追到现在，节奏把控越来越好。最喜欢的还是苏念这个角色，她的神秘感和坚强让人着迷。不过最近几章的更新频率好像慢了一点点，竹巷老师注意身体啊，我们等你！PC端和手机端都能看，追书体验真的很方便。',
    date: '2026-08-03',
    likes: 987,
  },
  {
    id: 'rv-5',
    userName: '剑走偏锋',
    avatar: '',
    rating: 5,
    content: '八百万字实打实的内容，没有一句废话。竹巷的笔力在整个网文圈都是顶尖的。这本书的悬疑线埋得特别深，每一个看似无用的细节最后都会汇成线索。我已经重读了三遍了，每次都有新的发现。笔趣阁的排版和阅读体验也是我用过最好的。',
    date: '2026-08-02',
    likes: 1345,
  },
  {
    id: 'rv-6',
    userName: '清风徐来',
    avatar: '',
    rating: 5,
    content: '作为一个看了二十年网文的老书虫，《公厕》绝对是我心目中的Top 3。它不像那些套路化的爽文，而是真正在讲故事、写人物。林远、苏念、老陈，每一个角色都栩栩如生。笔趣阁的同步更新速度真的没话说，推荐所有朋友来这里追更！',
    date: '2026-08-01',
    likes: 2103,
  },
];

export interface BrandInfo {
  siteName: string;
  subtitle: string;
  foundedYear: number;
  description: string;
  features: { title: string; description: string; icon: string }[];
  stats: { label: string; value: string }[];
}

export const brandInfo: BrandInfo = {
  siteName: '笔趣阁',
  subtitle: '全网最速小说更新平台',
  foundedYear: 2018,
  description: '笔趣阁成立于2018年，是国内领先的正版小说阅读与更新平台。我们致力于为读者提供最快、最全、最优质的小说阅读体验。平台汇聚海量热门小说资源，覆盖玄幻、都市、言情、武侠、科幻等全品类，与数千位作者保持紧密合作，确保小说更新与作者同步，让读者第一时间获取最新章节内容。',
  features: [
    {
      title: '极速同步更新',
      description: '与作者后台实时对接，最新章节发布后秒级同步至平台，让读者永远领先一步。平均同步延迟不超过3分钟，行业领先。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '全文无删减',
      description: '坚持提供完整原版内容，拒绝任何形式的删减和修改，保留作者原汁原味的创作表达，为读者呈现最真实的阅读体验。',
      icon: 'ri-file-text-line',
    },
    {
      title: '多端无缝阅读',
      description: '支持PC端、手机端、平板电脑等多设备无缝切换阅读。云端自动保存阅读进度，随时随地接着看，阅读体验不间断。',
      icon: 'ri-device-line',
    },
    {
      title: '海量书库资源',
      description: '平台收录超过十万部小说作品，涵盖玄幻奇幻、武侠仙侠、都市言情、历史军事、科幻灵异、网游竞技等全部主流品类。',
      icon: 'ri-book-open-line',
    },
  ],
  stats: [
    { label: '收录小说', value: '128,560+' },
    { label: '活跃读者', value: '2,860万+' },
    { label: '累计字数', value: '86亿+' },
    { label: '合作作者', value: '3,200+' },
  ],
};